import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Render error caught by ErrorBoundary:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '2rem', gap: '1rem' }}>
          <h2 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1.25rem', fontWeight: 700, color: '#0076A3' }}>Something went wrong</h2>
          <p style={{ fontSize: '0.875rem', color: '#64748B', maxWidth: 420 }}>
            This page hit an unexpected error. You can go back and try again — your data is safe.
          </p>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button data-testid="error-boundary-back" onClick={() => { this.handleReset(); window.history.back(); }} style={{ background: '#0076A3', color: '#fff', border: 'none', borderRadius: 10, padding: '0.5rem 1rem', fontSize: '0.8125rem', fontWeight: 600, cursor: 'pointer' }}>Go Back</button>
            <button data-testid="error-boundary-reload" onClick={() => window.location.reload()} style={{ background: '#fff', color: '#0076A3', border: '1px solid #CBD5E1', borderRadius: 10, padding: '0.5rem 1rem', fontSize: '0.8125rem', fontWeight: 600, cursor: 'pointer' }}>Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
